import { useEffect, useState } from "react";
import Table from "../../../components/common/table/Table";
import Title from "../../../components/common/title/Title";
import { getApi } from "../../../services/api/globalApi";
import { digitsThree } from "../../../utils/price";
import ExportExcel from "../../../components/common/export-exel/ExportExel";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";
import { useSelector } from "react-redux";
import { usersOldReportsColumns } from "../../../constant/tablesColumns/tablesColums";

export default function UsersOldReports() {
  const [userReportsData, setUsersReportsData] = useState([]);
  const { utils } = useSelector(utilsState);

  const getProductReports = async () => {
    const path = "admin/reports/usersTotalSalesTempBarayeHesabDar";
    try {
      const response = await getApi({ path });
      setUsersReportsData(response?.data?.result);
      console.log(response?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getProductReports();
  }, []);

  const data = [];

  userReportsData?.map((item) =>
    data.push({
      ...item,
      name: item?.userInfo?.name,
      mobile: item?.userInfo?.mobile,
      role: utils?.ROLES[item?.userInfo?.role].name || "",
      tirNaKhales: digitsThree(item?.userInfo?.sales?.tirNaKhales),
      tir: digitsThree(item?.userInfo?.sales?.tir),
      mordadNaKhales: digitsThree(item?.userInfo?.sales?.mordadNaKhales),
      mordad: digitsThree(item?.userInfo?.sales?.mordad),
      shahrivarNaKhales: digitsThree(item?.totalPrice),
      shahrivar: digitsThree(item?.finalPrice),
      totalNakhales: digitsThree(item?.totalNakhales),
      id: item._id,
    })
  );

  const exportReportsData = [];

  userReportsData?.map((item) =>
    exportReportsData.push({
      نام: item?.userInfo?.name,
      موبایل: item?.userInfo?.mobile,
      نقش: utils?.ROLES[item?.userInfo?.role].name || "",
      "ناخلص تیر": item?.userInfo?.sales?.tirNaKhales || 0,
      "خالص تیر": item?.userInfo?.sales?.tir || 0,
      "ناخالص مرداد": item?.userInfo?.sales?.mordadNaKhales || 0,
      "خالص مرداد": item?.userInfo?.sales?.mordad || 0,
      "ناخالص شهریور": item?.totalPrice,
      "خالص شهریور": item?.finalPrice,
      "ناخالص کل": item?.totalNakhales,
    })
  );

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex flex-col sm:flex-row justify-betwseen items-center">
        <Title title={"گزارش تابستان کاربران"} />
        <div className="w-full mt-4 sm:mt-0 flex justify-end">
          <ExportExcel jsonData={exportReportsData} />
        </div>
      </div>
      <Table columns={usersOldReportsColumns} rows={data} />
    </div>
  );
}
